import useKwaiPlayer from '@/hooks/useKwaiPlayer';
import Styles from './index.module.scss';

import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import Control, { VideoStatus, VideoVolumeOperations } from './Control';
interface IProps {
  src: string;
  showCustomerControl?: boolean;
  playerLoaded?: Function;
  [index: string]: any;
}

const KsVideoPlayer = ({ src, showCustomerControl, ...props }: IProps, ref) => {
  // 动态引入 播放器
  const KwaiPlayerReact = useKwaiPlayer();

  const videoRef = useRef(null);
  const controlRef = useRef(null);

  const [currentTime, setCurrentTime] = useState(0);
  const currentTimeRef = useRef(null);
  currentTimeRef.current = currentTime;
  const [syncCurrentTime, setSyncCurrentTime] = useState(0); // 组合视频和原视频时间同步
  const syncCurrentTimeRef = useRef(null);
  syncCurrentTimeRef.current = syncCurrentTime;
  const [duration, setDuration] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false); // 是否全屏
  const showControls = useRef(null); // 是否展示原生control, 全屏时展示，非全屏时不展示
  showControls.current = isFullScreen;
  const [fullScreenFunction, setFullScreenFunction] = useState();

  // timeupdate
  const timeupdate = () => {
    setCurrentTime(videoRef?.current?.currentTime || 0);
  };
  const onLoadedMetadata = () => {
    setDuration(videoRef?.current?.duration || 0);
  };
  // 开始播放
  const onPlaying = () => {
    if (syncCurrentTimeRef.current) {
      videoRef.current.currentTime = syncCurrentTimeRef.current;
      // 每次使用后清空
      setSyncCurrentTime(0);
    }
    controlRef.current?.setVideoStatus(VideoStatus.played);
  };
  // 暂停
  const onPause = () => {
    controlRef.current?.setVideoStatus(VideoStatus.paused);
  };

  // 播放/暂停
  const playOrPause = (type?: string) => {
    let res;
    if (type === 'paly') {
      videoRef.current.play();
      res = VideoStatus.played;
    } else if (type === 'pause') {
      videoRef.current.pause();
      res = VideoStatus.paused;
    } else if (videoRef.current.paused) {
      videoRef.current.play();
      res = VideoStatus.played;
    } else {
      videoRef.current.pause();
      res = VideoStatus.paused;
    }
    return res;
  };
  // 播放结束后暂停
  const onEnded = () => {
    setSyncCurrentTime(0);
  };

  // 全屏
  const requestFullScreen = () => {
    videoRef.current.requestFullscreen();
  };
  const onFullScreenchange = (e) => {
    if (!e.isFull) {
      // 退出全屏时
      setSyncCurrentTime(currentTimeRef.current); // 记录全屏时的currentTime
      setCustomUrl(null);
    }
    setIsFullScreen(e.isFull);
  };

  useEffect(() => {
    if (process.browser && KwaiPlayerReact) {
      props?.playerLoaded();
    }
  }, [KwaiPlayerReact]);

  // 声音
  const [muted, setMuted] = useState(true);
  const volumeChange = (val: number) => {
    setMuted(val === 0);
    videoRef.current.volume = val;
  };

  const [customUrl, setCustomUrl] = useState(null);
  useImperativeHandle(ref, () => {
    return {
      // 全屏指定视频
      fullScreenCustomUrl: (url) => {
        // 记录组合视频的currentTime
        setSyncCurrentTime(currentTime);
        setCustomUrl(url);
        requestFullScreen();
      },
    };
  });

  if (KwaiPlayerReact) {
    return (
      <div>
        <KwaiPlayerReact
          ref={videoRef}
          id="videoPlayer"
          src={customUrl || src}
          autoPlay={true}
          controls={isFullScreen}
          preload="auto"
          onTimeUpdate={timeupdate}
          onLoadedMetadata={onLoadedMetadata}
          onPlaying={onPlaying}
          onPause={onPause}
          onEnded={onEnded}
          onFullscreenchange={onFullScreenchange}
          // className={Styles.playContainer}
          {...Object.assign({}, isFullScreen ? {} : { muted: muted })}
          {...props}
        />
        {showCustomerControl && (
          <Control
            ref={controlRef}
            video={videoRef.current}
            currentTime={currentTime}
            duration={duration}
            muted={muted}
            playOrPause={playOrPause}
            requestFullScreen={requestFullScreen}
            volumeChange={volumeChange}
            seek={(val) => {
              videoRef.current.currentTime = val;
            }}
          />
        )}
      </div>
    );
  }
  return <div></div>;
};

export default forwardRef(KsVideoPlayer);
